import {
  GET_ALL_SUMMARIES,
  GET_ALL_SUMMARIES_FAIL,
  GET_ALL_SUMMARIES_SUCCESS,
  GET_SUMMARY_DETAILS,
  GET_SUMMARY_DETAILS_FAIL,
  GET_SUMMARY_DETAILS_SUCCESS,
  CREATE_SUMMARY,
  CREATE_SUMMARY_FAIL,
  CREATE_SUMMARY_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  stateDetails: {},

  summaries: {
    summary: [],
    total: "",
    page: "",
  },
  summaryDetails: {},
  error: {},
  loading: false,
}

const Summary = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Summary - This line cannot be edited or removed
    case GET_ALL_SUMMARIES:
    case GET_SUMMARY_DETAILS:
    case CREATE_SUMMARY:
      return {
        ...state,
        loading: true,
      }

    case GET_ALL_SUMMARIES_FAIL:
    case GET_SUMMARY_DETAILS_FAIL:
    case CREATE_SUMMARY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_ALL_SUMMARIES_SUCCESS:
      return {
        ...state,
        summaries: action.payload,
        error: {},
        loading: false,
      }

    case GET_SUMMARY_DETAILS_SUCCESS:
      return {
        ...state,
        summaryDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_SUMMARY_SUCCESS:
      return {
        ...state,
        summaries: {
          ...state.summaries,
          summary: [action.payload, ...state.summaries.summary],
          total: state.summaries.total + 1,
        },
        summaryDetails: action.payload,
        error: {},
        loading: false,
      }

    // State - This line cannot be edited or removed

    default:
      return state
  }
}

export default Summary
